export default __webpack_public_path__ + "static/media/x6-demo-1.4343eb00.png";